import { combineReducers } from 'redux';

import productList from './product-list-reducer';
import productPrices from './price-reducer';
import sortReducer from './sort-reducer';

const preSortData = combineReducers({
    productList,
    productPrices
});

const NULL_STATE = {
    productList: {},
    productPrices: {},
}

const ProductInfoReducer = (state = NULL_STATE, action) => {
    const intermediateState = preSortData(state,action);
    const finalState = sortReducer(intermediateState, action);
    return finalState;
}

export default ProductInfoReducer;
